import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../analytics';
import { setLastRegistrationStep } from '../registrationMeta';
import { pathToScreenName, screenNameToStep } from '../screenName';
import { trackRegistrationAbandoned } from '../trackRegistrationOutcome';
import { toAnalyticsPagePath } from '../utils/toAnalyticsPagePath';
import { getAccountId } from '../../utils/storage';

/**
 * SPA `screen_view` + best-effort `registration_abandoned` (`pagehide` only).
 * Mount once inside BrowserRouter.
 *
 * `/error` screen_view is owned by the Error page (needs error_code / error_message).
 */
export function AnalyticsRouterListener(): null {
    const location = useLocation();

    useEffect(() => {
        const path = toAnalyticsPagePath(
            location.pathname || '/',
            location.search
        );
        analytics.setCurrentPath(path);

        const step = screenNameToStep(pathToScreenName(path));
        if (step) {
            setLastRegistrationStep(step);
        }

        if ((location.pathname || '/') !== '/error') {
            analytics.pageView(path);
        }
    }, [location.pathname, location.search]);

    useEffect(() => {
        const onPageHide = () => {
            if (!getAccountId()) {
                return;
            }
            trackRegistrationAbandoned();
        };

        window.addEventListener('pagehide', onPageHide);
        return () => window.removeEventListener('pagehide', onPageHide);
    }, []);

    return null;
}
